import _pt from 'prop-types'

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {}
  var target = _objectWithoutPropertiesLoose(source, excluded)
  var key, i
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source)
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i]
      if (excluded.indexOf(key) >= 0) continue
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue
      target[key] = source[key]
    }
  }
  return target
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {}
  var target = {}
  var sourceKeys = Object.keys(source)
  var key, i
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i]
    if (excluded.indexOf(key) >= 0) continue
    target[key] = source[key]
  }
  return target
}

import React from 'react'
const {createElement, cloneElement} = React
import {Target as DisclosureTarget} from '@accessible/disclosure'
export {
  Disclosure as Drawer,
  DisclosureContext as DrawerContext,
  DisclosureConsumer as DrawerConsumer,
  useDisclosure as useDrawer,
  Close,
  Trigger,
  useIsOpen,
  useControls,
} from '@accessible/disclosure'

const __DEV__ =
  typeof process !== 'undefined' && process.env.NODE_ENV !== 'production'

const defaultClosedStyles = {
  top: {
    margin: 0,
    top: 0,
    right: 0,
    bottom: 'auto',
    left: 0,
    transform: 'translate3d(0, -100%, 0)',
  },
  right: {
    margin: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 'auto',
    transform: 'translate3d(100%, 0, 0)',
  },
  bottom: {
    margin: 0,
    top: 'auto',
    right: 0,
    bottom: 0,
    left: 0,
    transform: 'translate3d(0, 100%, 0)',
  },
  left: {
    margin: 0,
    top: 0,
    right: 'auto',
    bottom: 0,
    left: 0,
    transform: 'translate3d(-100%, 0, 0)',
  },
}
const defaultOpenStyles = {
  transform: 'translate3d(0, 0, 0)',
}
const defaultStyles = {
  position: 'fixed',
  margin: 'auto',
  left: '50%',
  top: '50%',
  transform: 'translate3d(-50%, -50%, 0)',
}
export const Target = _ref => {
  let {placement = 'left', openStyle} = _ref,
    props = _objectWithoutProperties(_ref, ['placement', 'openStyle'])

  const childProps = props.children.props
  return createElement(
    DisclosureTarget,
    Object.assign(props, {
      openStyle: Object.assign({}, defaultOpenStyles, openStyle),
    }),
    cloneElement(props.children, {
      style: Object.assign(
        {},
        defaultStyles,
        defaultClosedStyles[placement],
        childProps.style
      ),
    })
  )
}
/* istanbul ignore next */

Target.propTypes = {
  placement: _pt.oneOf(['top', 'right', 'bottom', 'left']),
}

if (__DEV__) {
  Target.displayName = 'Target'
}
